import Loading from "components/loading";
import { forwardRef, ReactNode, useMemo } from "react";
import { ButtonStyleType, Container } from "./styles";

type ButtonType = ButtonStyleType & {
  children: ReactNode;
  loading?: boolean;
  icon?: ReactNode;
  type?: "button" | "submit" | "reset";
  title?: string;
  onClick?: () => void;
};

const Button = forwardRef<HTMLButtonElement, ButtonType>(
  ({ children, loading, icon, onClick, type = "button", ...args }, ref) => {
    const disabled = useMemo(() => loading || args.$disabled, [loading, args]);

    return (
      <Container
        {...args}
        ref={ref}
        type={type}
        disabled={disabled}
        onClick={() => !disabled && onClick?.()}
      >
        <code>{loading ? <Loading /> : icon}</code>
        {children}
      </Container>
    );
  }
);

export default Button;
